var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h20v20H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.882.034a1 1 0 0 1 1.257 1.018l-.705 13.583a1 1 0 0 1-1.628.725l-3.109-2.517a1 1 0 0 1 1.259-1.554l1.582 1.281.532-10.249-9.914 2.652 1.582 1.281c.43.348.496.977.148 1.406a.998.998 0 0 1-1.406.148L.371 5.291a1 1 0 0 1 .371-1.743L13.882.034zm-3.518 5.63a1 1 0 0 1 .148 1.405l-2.518 3.11a1 1 0 0 1-1.554-1.26l2.518-3.108a.998.998 0 0 1 1.406-.148z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.56a811997c3c679de2c0279c19294c49.svg";
export { ForwardRef as ReactComponent };